import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsApp } from "./IntegrationsApp";

export const Route = createFileRoute("/integrations/")({
  component: IntegrationsPage,
});

function IntegrationsPage() {
  // Integrations can run in both standalone mode (within ispm) and as a Single-SPA MFE (loaded by ui-track)
  // This route enables standalone mode for development and testing
  return <IntegrationsApp />;
}
